<template>
  <div
    class="banner-like-section"
  >
    <img
      :src="section.bg_img.url"
      alt=""
      :style="{ objectPosition: `${section.bg_img_x_pos}% ${section.bg_img_y_pos}%` }"
    >

    <div class="container">
      <div>
        <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
        <h2>
          <span
            class="text-bg-black"
            v-html="stripBlockTags(section.header)"
          />
        </h2>

        <div
          class="content"
          v-html="section.content"
        />

        <div
          v-if="section.link && section.link.url"
          class="link-container"
        >
          <a
            :href="section.link.url"
            :target="section.link.target"
            class="link btn"
          >
            {{ section.link.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
div.banner-like-section {
  position: relative;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    object-fit: cover;
  }

  > .container {
    position: relative;
    z-index: 2;

    > div {
      width: 100%;

      @media screen and (min-width: $breakpoint-lg) {
        width: 50%;
      }
    }

    h2 {
      color: $thd-white;
      text-align: left;
    }

    .content::v-deep {
      color: $thd-white;

      @media screen and (min-width: $breakpoint-lg) {
        font-size: 24px;
        line-height: 32px;
      }

      strong,
      b {
        color: $thd-orange;
      }
    }

    .link-container {
      margin-top: 48px;
      text-align: left;
    }
  }
}
</style>
